<template>
  <div id="modalBeneficio" ref="modalBen" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="editando">Editar beneficio</span>
            <span v-else>Crear beneficio</span>
          </h5>
          <div class="acciones-modal">
            <button type="button" class="btn btn-success" @click="clickGuardar()">
              <font-awesome-icon v-if="!guardando" :icon="Icons.ACEPTAR" />
              <div v-else id="indicador-guardado" class="spinner-border" role="status"></div>
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>

        <div class="modal-body">
          <Formulario ref="formulario">
            <formulario-beneficio ref="formularioBeneficio" :comercioFijo="comercioFijo" :comercioList="comercioList"
              :editando="editando" :item="item" :permitePrioridad="permitePrioridad" :facade="facade" :esAdmin="esAdmin"
              :tiposCodigoList="tiposCodigoList" />
          </Formulario>
        </div>
      </div>Editar beneficio
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Icons as IconConstants } from "../../../constants";
import { Util } from "../../../util";
import FormularioBeneficio from "../formularios/FormularioBeneficio.vue";
import Formulario from "../formularios/Formulario.vue";
import { EstadoLogo } from "../../../data/enums";
import { environment } from "../../../environments/environment";
import { Carpetas } from "../../../constants";


// Usado para realizar copias profundas y para que las computed properties funcionen correctamente
// a la hora de limpiar los datos del beneficio solo hay que hacer copiaProfunda de este objeto
const BENEFICIO_LIMPIO = {
  activo: true,
  description: null,
  descuentos: [],
  diasHabilitados: [],
  idComercio: null,
  idSubCategoria: null,
  idTipoCodigo: null,
  labelBotonCodigo: null,
  labelBotonLibre: null,
  logoUrl: null,
  medioPago: null,
  nombre: null,
  nombreComercio: null,
  prioridad: null,
  urlBotonLibre: null,
  usaQR: null,
  usaTienda: null,
  tags: []
};

/** Cuando se cerró el modal */
const EVENTO_CERRADO = "cerrado";
/** Cuando se terminó de crear */
const EVENTO_CREADO = "creado";
/** Cuando se terminó de editar */
const EVENTO_EDITADO = "editado";

export default {
  components: {
    FontAwesomeIcon,

    FormularioBeneficio,
    Formulario
  },
  props: {
    /** Si es verdadero, el comercio no se podrá cambiar */
    comercioFijo: {
      type: Boolean,
      default: false
    },
    comercioList: Array,
    /** Utilizado para cargar y guardar datos */
    facade: Function,
    permitePrioridad: {
      type: Boolean,
      default: true
    },
    esAdmin: {
      type: Boolean,
      default: true
    },
    tiposCodigoList: Array,
  },
  data() {
    return {
      editando: false,
      guardando: false,
      item: Util.copiaProfunda(BENEFICIO_LIMPIO),
      modal: null
    };
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    /**
     * @param {object} item Item editado, si no se pasa, se abre en modo creación
     */
    EventoAbrir(item = null) {
      if (item) {
        // Trabajar con una copia profunda para que no se apliquen los cambios directamente
        this.item = Util.copiaProfunda(item);
        this.editando = true;
        if (item.logoUrl) {
          const urlAbsoluta = this.CarpetaLogos + item.logoUrl;
          this.$refs.formularioBeneficio.callEventoCargarURL(urlAbsoluta);
        }

        // Quito los Tipos de descuentos que ya tiene cargado el Beneficio
        // Se permite solo un tipo de descuento distinto por beneficio
      } else {
        this.item = Util.copiaProfunda(BENEFICIO_LIMPIO);
        this.editando = false;
      }
      this.$refs.formulario.limpiarFeedback();
      this.modal.show();
    },
    EventoCerrar() {
      this.cerrar();
    },

    // ------------  Métodos internos -----------------------
    async catchSavingError(error) {
      if (error.response) {
        const data = error.response.data;
        if (data) {
          if (
            data.message === "BENEFICIO_DISCOUNT_PERCENTAGE_BELOW_MINIMUM_ERROR"
          ) {
            const comercioId = this.item.idComercio;
            const minimumDiscountPercentage = (
              await this.facade.getMinimumDiscountPercentageByComercioId(
                comercioId
              )
            ).data;

            const messageText = `El porcentaje de descuento no puede ser menor al mínimo para este comercio
             (${minimumDiscountPercentage}%)`;

            return Swal.fire({
              icon: "error",
              title: "Error",
              text: messageText
            });
          }
        }
      }

      return Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error inesperado"
      });
    },
    cerrar() {
      this.$emit(EVENTO_CERRADO);
      this.modal.hide();
    },
    clickCerrar() {
      this.cerrar();
    },
    subirLogo(idBeneficio) {
      let archivo = null;
      if (this.$refs.formularioBeneficio.getArchivoLogo()) {
        archivo = this.$refs.formularioBeneficio.getArchivoLogo();
      }
      const formData = new FormData();
      formData.append("image", archivo);
      return this.facade.uploadLogo(idBeneficio, formData);
    },
    subirLogoSiCorresponde(idBeneficio) {
      return new Promise((resolve, reject) => {
        // Solo se guarda cuando es un logo nuevo y no el original
        switch (this.$refs.formularioBeneficio.getEstadoLogo()) {
          case EstadoLogo.vacio:
            this.subirLogo(idBeneficio)
              .then(() => {
                // Guardar el nombre del logo
                this.item.logoUrl = null;

                // Promesa exitosa, logo subido
                resolve();
              })
              // Hubo un error, la promesa falla y se pasa el error hacia arriba
              .catch(error => reject(error));
            break;

          case EstadoLogo.nuevo:
            this.subirLogo(idBeneficio)
              .then(respuesta => {
                // Guardar el nombre del logo
                this.item.logoUrl = respuesta.data.Name;

                // Promesa exitosa, logo subido
                resolve();
              })
              // Hubo un error, la promesa falla y se pasa el error hacia arriba
              .catch(error => reject(error));
            break;


          case EstadoLogo.original:
            resolve();
            break;
        }
      })
    },
    clickGuardar() {

      if (!this.item.limiteDescuento || (this.item.limiteDescuento == "") || (this.item.limiteDescuento == " ") || (this.item.limiteDescuento <= 0)) {
        this.item.limiteDescuento = -1;
      }

      if (!this.item.descuentos ||
        !this.item.descuentos.length) {
        return Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor agregue un descuento"
        });
      }

      // Chequear el valor de usaQR, si es falso, enviarlo null
      if (this.item.usaQR == false) {
        this.item.usaQR = null;
      }

      // Chequear el valor de usaTienda, si es falso, enviarlo null
      if (this.item.usaTienda == false) {
        this.item.usaTienda = null;
      }

      if (this.$refs.formulario.esValido()) {
        this.guardando = true;

        if (this.editando) {
          this.facade.update(this.item)
            .then(() => {
              // Ahora hay que subir el logo, solo cerramos el modal si todo sale bien
              this.subirLogoSiCorresponde(this.item.id)
                // Solo se cierra si sale bien
                .then(() => this.cerrar())
                // Error al guardar el logo
                .catch(() => Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Ocurrió un error al subir logo"
                }))
                // Ocultar el feedback de guardando (ruedita que gira en el boton guardar)
                .finally(() => this.$emit(EVENTO_EDITADO, this.item),
                  this.guardando = false);
            })
            // Error al guardar el beneficio
            .catch(error => {
              this.catchSavingError(error);
              this.guardando = false;
            })
        }
        // Se está creando
        else {
          this.facade.create(this.item)
            .then(resp => {
              const itemCreado = resp.data;
              this.subirLogoSiCorresponde(itemCreado.id)
                // Solo se cierra si sale bien
                .then(() => this.cerrar())
                // Error al guardar el logo
                .catch(() => Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Ocurrió un error al subir logo"
                }))
                // Ocultar el feedback de guardando (ruedita que gira en el boton guardar)
                .finally(() => this.$emit(EVENTO_CREADO, itemCreado), this.guardando = false);
            })
            .catch(error => {
              this.catchSavingError(error);
              this.guardando = false;
            })
        }
      }
      else {
        this.$refs.formulario.mostrarFeedback();
      }

    },
    limpiarPondImagen() {
      this.$refs.formularioBeneficio.limpiarPondImagen();
    },
    limpiarValorDescuento() {
      this.$refs.formularioBeneficio.limpiarValorDescuento();
    }
  },
  mounted() {
    const opcionesModal = {};
    this.modal = new bootstrap.Modal(
      document.getElementById("modalBeneficio"),
      opcionesModal
    );

    this.$refs.modalBen.addEventListener('hidden.bs.modal', () => {
      this.limpiarPondImagen();
      this.limpiarValorDescuento();
    });

  }
};
</script>
<style scoped>
#indicador-guardado {
  width: 16px;
  height: 16px;
}
</style>
